import { PROFILE_UPDATED, UNAUTHENTICATED } from "../actions";
import { Profile } from "../types";
import LogRocket from "logrocket";
import { formatName } from "../libs/formatName";
import * as Sentry from "@sentry/browser";

export const initialState = {} as Profile;

export type ProfileState = typeof initialState;

export default function(state = initialState, action) {
	switch (action.type) {
		case PROFILE_UPDATED: {
			const profile = action.profile;

			const { userId, firstName, lastName, email } = profile;
			const name = formatName(firstName, lastName);
			LogRocket.identify(userId, {
				name,
				email,
			});

			Sentry.configureScope(function(scope) {
				scope.setUser({ id: userId, username: name, email });
			});

			return { ...state, ...profile };
		}

		case UNAUTHENTICATED: {
			return initialState;
		}

		default:
			return state;
	}
}
